<template>
<div class="checkout-progress">
    <div class="panel panel-default">
        <div class="panel-heading">Rechnungsinformationen</div>
        <div class="panel-body" v-if="billing">
            <template v-if="billing.debitor_number">
                <b>Debitor nr.:</b> {{ billing.debitor_number }}
                <br><br>
            </template>
            {{ billing.company }} <br>
            {{ billing.street }} <br>
            {{ billing.zip }} {{ billing.city }} <br>
            {{ billing.countryName }} <br>
        </div>
        <div class="panel-heading">Versandinformationen</div>
        <div class="panel-body" v-if="shipping && source !== 'multiple'">
            {{ shipping.company }} <br>
            {{ shipping.name }} <br>
            {{ shipping.street }} <br>
            {{ shipping.zip }} {{ shipping.city }} <br>
            {{ shipping.countryName }} <br>
        </div>
        <div class="panel-body" v-if="source === 'multiple'">
            Versand an mehrere Adressen.
        </div>
        <div class="panel-heading">Versandart</div>
        <div class="panel-body">
            Standard
        </div>
        <div class="panel-heading">Zahlungsinformationen</div>
        <div class="panel-body">
            Interne Rechnungslegung
        </div>
    </div>
</div>
</template>

<script>
export default {
  data() {
      return {
        billing: null,
        shipping: null,
        source: 'user'
      }
  },

  created() {
      App.event.listen('billing.changed', billing => this.billing = billing);
      App.event.listen('shipping.changed', shipping => this.shipping = shipping);
      App.event.listen('shipping.source.changed', ({who}) => { this.source = who; });
  }
}
</script>
